function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
export var GET_AUTHENTICATION_REQUEST = "GET_AUTHENTICATION_REQUEST";
export var GET_AUTHENTICATION_SUCCESS = "GET_AUTHENTICATION_SUCCESS";
export var GET_AUTHENTICATION_FAILURE = "GET_AUTHENTICATION_FAILURE";
export var REST_GET_AUTHENTICATION = "REST_GET_AUTHENTICATION";

//Fetches login status from Front API unless it is cached.
//Relies on Redux Thunk middleware.
export var fetchAuthentication = function fetchAuthentication() {
  return _defineProperty({}, CALL_API, {
    types: [GET_AUTHENTICATION_REQUEST, GET_AUTHENTICATION_SUCCESS, GET_AUTHENTICATION_FAILURE],
    endpoint: "authentication",
    init: {
      credentials: "same-origin"
    }
  });
};
export var SET_AUTHENTICATION = "SET_AUTHENTICATION";
export var setAuthentication = function setAuthentication(authentication) {
  return {
    authentication: authentication,
    type: SET_AUTHENTICATION
  };
};
export var LOGOUT_REQUEST = "LOGOUT_REQUEST";
export var LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export var LOGOUT_FAILURE = "LOGOUT_FAILURE";
export var RESET_LOGOUT = "RESET_LOGOUT";
export var logout = function logout() {
  return _defineProperty({}, CALL_API, {
    types: [LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE],
    endpoint: "logout2",
    init: {
      credentials: "same-origin"
    }
  });
};